"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionArea = void 0;
var react_1 = __importDefault(require("react"));
var lib_1 = require("../lib");
var baseStyles = lib_1.scopedStyles("ActionArea-base", {
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "inherit",
    fontSize: "inherit",
    margin: 0,
    padding: 0,
    color: "inherit",
    fontWeight: "inherit",
    textDecoration: "none",
});
var disabledStyles = lib_1.scopedStyles("ActionArea-disabled", {
    pointerEvents: "none",
    // Must explicitly change the cursor to defualt. Otherwise, when "pointer-events: none"
    // is applied on click, the cursor will not return to default until the mouse is moved.
    cursor: "default",
});
function ActionArea(props) {
    var action = props.action, children = props.children, title = props.title;
    var className = props.className || "";
    var button = function (opts) {
        var onClick = opts.onClick, onMouseDown = opts.onMouseDown, type = opts.type;
        return (react_1.default.createElement("button", { className: baseStyles + " " + className, onClick: onClick, onMouseDown: onMouseDown, type: type || "button", title: title }, children));
    };
    var span = function (extraClassName) {
        if (extraClassName === void 0) { extraClassName = ""; }
        return (react_1.default.createElement("span", { className: baseStyles + " " + disabledStyles + " " + className + " " + extraClassName, title: title }, children));
    };
    var link = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        var currentPath = props.currentPath ||
            (typeof location !== "undefined" ? location.pathname : "");
        var download = opts.download, newWindow = opts.newWindow;
        if (url === currentPath && !download)
            return span("current");
        return (react_1.default.createElement("a", { className: baseStyles + " " + className, download: download, href: url, rel: newWindow ? "noopener" : undefined, target: newWindow ? "_blank" : undefined, title: title }, children));
    };
    if (action === "disabled")
        return span();
    if (action === "submit")
        return button({ type: "submit" });
    if (typeof action === "function")
        return button({ onClick: action });
    if (typeof action === "string")
        return link(action);
    if ("download" in action)
        return link(action.url, { download: action.download });
    if ("mousedown" in action)
        return button({ onMouseDown: action.mousedown });
    if ("newWindow" in action)
        return link(action.newWindow, { newWindow: true });
    throw new Error("Unexpected action");
}
exports.ActionArea = ActionArea;
//# sourceMappingURL=ActionArea.js.map